import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import ComponentName from '../../constant/ComponentName';

export type BulkActionType = 'REMOVE' | 'DEPLOY' | 'UNDEPLOY';

export interface BulkActionDependency {
  componentType: string;
  componentId: string;
}

export interface BulkActionDependencyError {
  id: string;
  dependencies: BulkActionDependency[];
}

export interface BulkActionPayload {
  actionType: BulkActionType;
  componentName: ComponentName;
  selectedStatuses: string[];
  hasMixedStatuses: boolean;
  onConfirm: () => void;
  dependencyErrors?: BulkActionDependencyError[];
}

export interface BulkActionState {
  isOpen: boolean;
  payload: BulkActionPayload | null;
}

export type BulkActionActions = 'OPEN_BULK_ACTION_DIALOG' | 'CLOSE_BULK_ACTION_DIALOG' | 'SET_BULK_ACTION';

const initialState: BulkActionState = {
  isOpen: false,
  payload: null,
};

export const bulkActionReducer = (state: BulkActionState = initialState, action: ReduxBaseAction<BulkActionActions>) => {
  switch (action.type) {
    case 'OPEN_BULK_ACTION_DIALOG':
      return {
        ...state,
        isOpen: true,
        payload: action.payload,
      };
    case 'CLOSE_BULK_ACTION_DIALOG':
      return {
        ...state,
        isOpen: false,
        payload: null,
      };
    case 'SET_BULK_ACTION':
      return {
        ...state,
        isOpen: true,
        payload: action.payload,
      };
    default: {
      return state;
    }
  }
};
